export default "__VITE_ASSET__EPpdNUXx__"